import { Component, OnInit, ViewChild } from '@angular/core';
import { ServiceProvider } from '../models/service-provider';
import { User } from '../models/user';
import { ServiceProviderService } from '../services/service-provider/service-provider.service';
import { ForuscareService } from '../services/foruscare/foruscare.service';
import { OrderPipe } from 'ngx-order-pipe';
import { UserService } from '../services/user/user.service';
import { Address } from '../models/address';
import { AccountService } from '../services/account/account.service';

import { ModalDirective } from 'ngx-bootstrap/modal';
import { Language } from '../models/language';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { CommonModule } from '@angular/common';



@Component({
  selector: 'app-service-provider',
  templateUrl: './service-provider.component.html',
  styleUrls: ['./service-provider.component.css']
})
export class ServiceProviderComponent implements OnInit {

  @ViewChild(ModalDirective, { static: true }) modal: ModalDirective;

  public serviceProviderLogo = null;

  listing: boolean = true;
  totalRecords: number = 0;
  serviceProviderCategories: any[];
  confirmPassword: string; userEmailExists: boolean = false; userMobileExists: boolean = false;
  showPassword: boolean = false; emailExists: boolean = false; mobileExists: boolean = false; nameExists: boolean = false;
  AIWorkflows = this.foruscareService.getAavailableAIFlows();
  rows = 10;
  public paging = {currentPage:  0};
  expertCategory: String;
  private searchTerms = new Subject<any[]>();  // Subject to emit search terms
  results: any[] = [];  // Store search results
  // getSerialNumber(indexval) {
  //   return (this.paging.currentPage * 10 - 10) + indexval;
  // }

  expertReviewCategoryDropdown = [
    { id: "Fundus", itemName: 'Fundus Only' },
    { id: "Refraction", itemName: 'Refraction Only' },
    { id: "RefractionAndFundus", itemName: 'Refraction and Fundus' }
  ];

  public serviceProviderInfo: ServiceProvider = new ServiceProvider();
  public serviceProviders: ServiceProvider[];
  public accounts: any[];
  public userInfo: User = new User();
  public dateFormatList: any[] = [];
  showPasswordPolicy: Boolean = false;
  isStrongPassword: Boolean = false;
  dropdownSettings: any = {};

  constructor(public accountService: AccountService, public serviceProviderService: ServiceProviderService, public foruscareService: ForuscareService, public orderPipe: OrderPipe, public userService: UserService) {
    this.serviceProviders = orderPipe.transform(this.serviceProviders, 'name');
    this.serviceProviderCategories = this.foruscareService.getServiceProviderCategories();
    this.setupSearch();
  }

  order: string = 'name';
  reverse: boolean = false;
  emailPattern = "";
  public timeZoneList: any[]; public defaultLanguageList: any[] = []; public languageList: any[]; public masterLanguageList: any[]; public selectedMasterLanguageList: any[]; public defaultLanguage;

  ngOnInit() {
    // this.getExistingServiceProviders(0);
    this.getExistingAccounts();
    this.getTimezoneList();
    this.getLanguageList();
    this.dateFormatList = ["dd/MM/yyyy", "dd/MMM/yyyy", "MMM/dd/yyyy", "MM/dd/yyyy", "dd/MM/yyyy hh:mm tt", "MMM/dd/yyyy hh:mm tt", "dd/MMM/yyyy hh:mm tt", "MM/dd/yyyy hh:mm tt", "dd/MM/yyyy H:mm", "dd/MMM/yyyy H:mm", "MM/dd/yyyy H:mm", "MMM/dd/yyyy H:mm",
      "dd-MM-yyyy", "dd-MMM-yyyy", "MMM-dd-yyyy", "MM-dd-yyyy", "dd-MM-yyyy hh:mm tt", "dd-MMM-yyyy hh:mm tt", "MMM-dd-yyyy hh:mm tt", "MM-dd-yyyy hh:mm tt", "dd-MM-yyyy H:mm", "dd-MMM-yyyy H:mm", "MMM-dd-yyyy H:m", "MM-dd-yyyy H:mm",
      "yyyy/dd/MM", "yyyy/dd/MMM", "yyyy/MMM/dd", "yyyy/MM/dd", "yyyy/dd/MM hh:mm tt", "yyyy/MMM/dd hh:mm tt", "yyyy/dd/MMM hh:mm tt", "yyyy/MM/dd hh:mm tt", "yyyy/dd/MM H:mm", "yyyy/dd/MMM H:mm", "yyyy/MM/dd H:mm", "yyyy/MMM/dd H:mm",
      "yyyy-dd-MM", "yyyy-dd-MMM", "yyyy-MMM-dd", "yyyy-MM-dd", "yyyy-dd-MM hh:mm tt", "yyyy-dd-MMM hh:mm tt", "yyyy-MMM-dd hh:mm tt", "yyyy-MM-dd hh:mm tt", "yyyy-dd-MM H:mm", "yyyy-dd-MMM H:mm", "yyyy-MMM-dd H:m", "yyyy-MM-dd H:mm"
    ];
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'itemName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
  }

  getTimezoneList() {
    this.timeZoneList = [];
    this.accountService.getTimeZoneList()
      .subscribe(response => {
        if (response != null && response.length > 0) {
          this.timeZoneList = response;
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  getTitle() {
    if (this.serviceProviderInfo.type == this.foruscareService.SERVICE_AI || this.serviceProviderInfo.type == this.foruscareService.SERVICE_READING_CENTER ||
      this.serviceProviderInfo.type == this.foruscareService.SERVICE_TELE_REFRACTION) {
      return "Reading Center Manager Info";
    }
    else if (this.serviceProviderInfo.type == this.foruscareService.SERVICE_SPECTACLE) {
      return "Spectacle Admin Info";
    }
  }

  getLanguageList() {
    this.languageList = [];
    this.masterLanguageList = [];
    this.accountService.getLanguagesList()
      .subscribe(response => {
        if (response.data != null && response.data.length > 0) {
          this.languageList = response.data;
          response.data.forEach(element => {
            this.masterLanguageList.push({ id: element.languageCode, itemName: element.language + " - " + element.description });
          });
          this.masterLanguageList.sort(function (a, b) {
            if (a.itemName.split(" - ")[1] > b.itemName.split(" - ")[1]) { return 1; }
            else if (a.itemName.split(" - ")[1] < b.itemName.split(" - ")[1]) { return -1; }
            return 0;
          });
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }


  convertUTCToLocal(utcString) {
    return this.foruscareService.convertUTCtoLocal(utcString);
  }

  getExistingAccounts() {
    this.accounts = [];
    this.accountService.getExistingAccounts()
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null && response.data.length > 0) {
            response.data.forEach(account => {
              this.accounts.push({
                id: account.accountId,
                itemName: account.accountName
              });
            });
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  setOrder(value: string) {
    if (this.order === value) {
      this.reverse = !this.reverse;
    }
    this.order = value;
  }

  toggleView() {
    this.listing = !this.listing;
    this.serviceProviderInfo = new ServiceProvider();
    this.confirmPassword = null;
    this.userInfo = new User();
    this.userInfo.roleName = this.foruscareService.ROLE_OPTHALMOLOGY_SUPERVISOR;
    this.serviceProviderInfo.type = this.foruscareService.SERVICE_READING_CENTER;
    let offset = new Date().getTimezoneOffset(), o = Math.abs(offset);
    this.serviceProviderInfo.timeZone = (offset < 0 ? "+" : "-") + ("00" + Math.floor(o / 60)).slice(-2) + ":" + ("00" + (o % 60)).slice(-2);
    this.serviceProviderInfo.language = navigator.language.slice(0, 2);
    this.serviceProviderInfo.dateFormat = this.dateFormatList[0];
    if (this.listing) {
      this.searchData.term = "";
        this.searchData.searchby = "";
       this.getExistingServiceProviders(0); 
      };
  }

  updateServiceProviderLogo(providerInfo: ServiceProvider) {
    if (providerInfo != null) {
      this.serviceProviderLogo = null;
      document.getElementById("fileuploader")["value"] = "";
      this.serviceProviderInfo = providerInfo;
      this.showModal();
    }
  }

  onStep1Next(event) {

  }

  onStep2Next(event) {

  }
  offset: number = 0;
  onPageChange(event) {
    this.offset = event.first;
    this.rows = event.rows;
    this.paging.currentPage = event.first;
    this.offset = event.first;
    this.getExistingServiceProviders(this.offset);
  }

  getExistingServiceProviders(offset) {
    let count = 10;
    this.serviceProviders = [];
    this.userService.serviceProvidersSearch(this.searchData.term, this.searchData.searchby, count, this.offset)
      .subscribe(response => {
        if (response.status == 200) {
          if (response.data != null) {
            response.data.response.forEach(element => {
              if (element.logo != null && element.logo.indexOf("blob.core.windows.net") == -1) {
                element.logo = element.logo + '?' + new Date().getTime();
              }
            });
            this.serviceProviders = response.data.response;
            this.totalRecords = response.data.totalCount;
            //get base64 data for logo
            this.serviceProviders.forEach(element => {
              if (element.logo != null && element.logo.indexOf("blob.core.windows.net") > -1) {
                this.serviceProviderService.getBlobURLtobase64(element.logo)
                  .subscribe(response => {
                    if (response != null && response.errorCode == 200) {
                      element.logo = "data:image/jpg;base64," + response.data;
                    }
                  });
              }
            });
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  editServiceProviderInfo(providerInfo: ServiceProvider) {
    if (providerInfo != null) {
      let accoundIds = providerInfo.accountIds;
      providerInfo.accountIds = [];
      if (accoundIds != null && accoundIds.length > 0 && this.accounts != null && this.accounts.length > 0) {
        accoundIds.forEach(accountId => {
          this.accounts.forEach(accountInfo => {
            if (accountId == accountInfo.id) {
              providerInfo.accountIds.push(accountInfo);
            }
          })
        })
      }
      if (providerInfo.aiMode != null && providerInfo.aiMode.length > 0) {
        let aiModes = providerInfo.aiMode.split(",");
        providerInfo.aiMode = [];
        this.serviceProviderInfo.aiMode = [];
        aiModes.forEach(aimode => {
          providerInfo.aiMode.push({
            id: aimode.trim(),
            itemName: this.foruscareService.getAIModeByKey(aimode.trim())
          })
        })
      }
      // if (providerInfo.timeZone != null) {
      //   if (!isNaN(parseFloat(providerInfo.timeZone))) {
      //     providerInfo.timeZone = parseFloat(providerInfo.timeZone);
      //   }
      // }
      this.selectedMasterLanguageList = [];
      this.defaultLanguageList = [];
      this.defaultLanguage = null;
      if (providerInfo.languageList != null && providerInfo.languageList.length > 0) {
        providerInfo.languageList.forEach(language => {
          this.selectedMasterLanguageList.push({ id: language.languageCode, itemName: language.language + " - " + language.description });
          this.defaultLanguageList = this.selectedMasterLanguageList;
          if (language.isDefault) {
            this.defaultLanguage = language.languageCode;
          }
        });
      }
      this.serviceProviderInfo = providerInfo;
      this.listing = false;
    }
  }

  getAddressString(address: Address): string {
    return this.foruscareService.getAddressString(address);
  }

  userEmailValidationService = null; userMobileValidationService = null;
  validateUserEmailExists(providerInfoForm) {
    if (providerInfoForm != null && providerInfoForm.form != null && providerInfoForm.form.controls != null && providerInfoForm.form.controls.userEmail != null && providerInfoForm.form.controls.userEmail.status == "INVALID")
      return;
    if (this.userEmailValidationService != null) {
      this.userEmailValidationService.unsubscribe();
    }
    this.userEmailValidationService = this.userService.checkEmailExists(this.userInfo.email)
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null && response.data.userEmailExists) {
            this.userEmailExists = true;
          }
          else this.userEmailExists = false;
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  closeLogoUpload() {
    this.closeModal();
    if (!this.listing) {
      this.toggleView();
    }
  }

  validateUserMobileExists() {
    if (this.userInfo != null && this.userInfo.phoneNo != null && this.userInfo.phoneNo.trim().length < 10)
      return;
    if (this.userMobileValidationService != null) {
      this.userMobileValidationService.unsubscribe();
    }
    this.userMobileValidationService = this.userService.checkMobileExists(this.userInfo.phoneNo)
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null && response.data.userPhoneNumberExists) {
            this.userMobileExists = true;
          }
          else this.userMobileExists = false;
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  getAccountName(accountId) {
    let accountName = "";
    if (this.accounts != null && this.accounts.length > 0) {
      this.accounts.forEach(accountInfo => {
        if (accountInfo.id == accountId) {
          accountName = accountInfo.itemName;
        }
      })
    }
    return accountName;
  }

  getTimeZone() {
    let timezone = this.timeZoneList.find(ob => ob['offset'] == this.serviceProviderInfo.timeZone);
    if (timezone != null)
      return timezone["value"];
  }

  getLanguage() {
    let languageinfo = this.languageList.find(ob => ob['alpha2'] == this.serviceProviderInfo.language);
    if (languageinfo != null)
      return languageinfo["English"];
  }

  getProviderType(key) {
    let type = this.serviceProviderCategories.find(ob => ob['categoryId'] == key);
    if (type != null)
      return type["categoryName"];
  }

  validateServiceProviderInfo(fieldToValidate: string) {
    if (fieldToValidate == "email") {
      if (this.serviceProviderInfo.email != null) {
        this.serviceProviderInfo.email = this.serviceProviderInfo.email.trim();
        let data = this.serviceProviders.filter(ob => ob['email'].toLowerCase() === this.serviceProviderInfo.email.toLowerCase());
        if (data != null) {
          if ((this.serviceProviderInfo.id != null && data.length > 1) || (this.serviceProviderInfo.id == null && data.length > 0)) {
            this.foruscareService.showNotification("Provider email already exists.", "warning");
            this.emailExists = true;
            return;
          }
          else {
            this.emailExists = false;
          }
        }
        else
          this.emailExists = false;
      }
    }
    else if (fieldToValidate == "mobile") {
      if (this.serviceProviderInfo.phone != null) {
        this.serviceProviderInfo.phone = this.serviceProviderInfo.phone.trim();
        let data = this.serviceProviders.filter(ob => ob['phone'].toLowerCase() === this.serviceProviderInfo.phone.toLowerCase());
        if (data != null) {
          if ((this.serviceProviderInfo.id != null && data.length > 1) || (this.serviceProviderInfo.id == null && data.length > 0)) {
            this.foruscareService.showNotification("Provider mobile already exists.", "warning");
            this.mobileExists = true;
            return;
          }
          else {
            this.mobileExists = false;
          }
        }
        else
          this.mobileExists = false;
      }
    }
    else if (fieldToValidate == "name") {
      if (this.serviceProviderInfo.name != null) {
        // this.accountInfo.name = this.accountInfo.name.trim();
        let data = this.serviceProviders.filter(ob => ob['name'].toLowerCase() === this.serviceProviderInfo.name.trim().toLowerCase());
        if (data != null) {
          if ((this.serviceProviderInfo.id != null && data.length > 1) || (this.serviceProviderInfo.id == null && data.length > 0)) {
            this.foruscareService.showNotification("Service provider name already exists.", "warning");
            this.nameExists = true;
            return;
          }
          else {
            this.nameExists = false;
          }
        }
        else
          this.nameExists = false;
      }
    }
  }

  showModal() {
    this.modal.show();
  }
  closeModal() {
    this.modal.hide();
  }

  imagePathToUpload = null;

  onFileChanged(event) {
    const file = event.target.files[0];
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      this.foruscareService.showNotification("Only image files are allowed.", "danger");
      event.target.value = "";
      return;
    }

    this.serviceProviderLogo = file;
    var oFReader = new FileReader();
    oFReader.readAsDataURL(event.target.files[0]);

    oFReader.onload = function (oFREvent) {
      document.getElementById("uploadPreview")["src"] = oFREvent.target["result"];
    };
  }

  uploadFile() {
    this.closeModal();
    // this.http is the injected HttpClient
    const uploadData = new FormData();
    uploadData.append("file", this.serviceProviderLogo);
    // uploadData.append("filename", this.serviceProviderLogo.name)
    // uploadData.append("providerId", this.serviceProviderInfo.id);
    this.serviceProviderService.uploadServiceProviderLogo(uploadData, this.serviceProviderInfo.id)
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null) {
            this.foruscareService.showNotification("Service provider logo uploaded successfully.", "success");
            this.serviceProviderLogo = null;
            document.getElementById("fileuploader")["value"] = "";
            this.closeModal();
            if (!this.listing) {
              this.toggleView();
            }
            else {
              this.getExistingServiceProviders(0);
            }
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  onComplete(event) {
    if (this.serviceProviderInfo == null)
      return;

    if (this.serviceProviderInfo.type == this.foruscareService.SERVICE_AI && (this.serviceProviderInfo.aiMode == null || this.serviceProviderInfo.aiMode.length == 0)) {
      this.foruscareService.showNotification("Please select workflows for selected AI Providider", "danger");
      return;
    }
    this.serviceProviderInfo.languageList = [];
    if (this.selectedMasterLanguageList != null && this.selectedMasterLanguageList.length > 0) {
      if (!this.defaultLanguage) {
        this.foruscareService.showNotification("Please select default language.", "danger");
        return;
      }
      this.languageList.forEach(allLanguage => {
        let temp: Language = allLanguage;
        this.selectedMasterLanguageList.forEach(selectedMasterLanguage => {
          if (allLanguage.languageCode == selectedMasterLanguage.id) {
            temp.isDefault = (selectedMasterLanguage.id == this.defaultLanguage) ? true : false;
            if (this.serviceProviderInfo.id != null) {
              temp.accountId = this.serviceProviderInfo.id;
            }
            this.serviceProviderInfo.languageList.push(temp);
          }
        });
      });
    }
    else {
      this.foruscareService.showNotification("Please select language.", "danger");
      return;
    }
    if (this.serviceProviderInfo.imageGrading && this.serviceProviderInfo.type != this.foruscareService.SERVICE_AI) {
      this.serviceProviderInfo.imageGrading = false;
    }

    if (this.serviceProviderInfo.accountIds != null) {
      if (this.serviceProviderInfo.accountIds.length == 0) {
        this.serviceProviderInfo.accountIds = null;
      }
      else {
        var accoundIds = this.serviceProviderInfo.accountIds.map(function (item) {
          return item.id;
        });
        this.serviceProviderInfo.accountIds = accoundIds;
      }
    }

    if (this.serviceProviderInfo.aiMode != null) {
      if (this.serviceProviderInfo.aiMode.length == 0) {
        this.serviceProviderInfo.aiMode = null;
      }
      else {
        var availableFlows = "";
        this.serviceProviderInfo.aiMode.forEach(flow => {
          if (availableFlows.trim().length > 0 && flow != null && flow.id != null && flow.id.trim().length > 0)
            availableFlows = availableFlows + ",";
          if (flow.id != null)
            availableFlows = availableFlows + flow.id;
        });
        this.serviceProviderInfo.aiMode = availableFlows;
      }
    }

    if (this.serviceProviderInfo.id != null) {
      this.serviceProviderService.updateServiceProvider(this.serviceProviderInfo)
        .subscribe(response => {
          if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
            if (response.data != null) {
              this.foruscareService.showNotification("Service Provider info updated successfully.", "success");
              this.toggleView();
            }
          }
          else {
            this.foruscareService.showNotification(response.message, "danger");
          }
        });
    } else {
      this.serviceProviderInfo.name = this.serviceProviderInfo.name.trim();
      this.serviceProviderService.createServiceProvider(this.serviceProviderInfo)
        .subscribe(response => {
          if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
            if (response.data != null) {
              this.foruscareService.showNotification("Service Provider created successfully.", "success");
              this.serviceProviderInfo = response.data;
              this.userInfo.providerId = response.data.id;
              this.userService.createUser(this.userInfo)
                .subscribe(response => {
                  if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
                    if (response.data != null) {
                      this.foruscareService.showNotification("Admin user created successfully.", "success");
                      this.toggleView();
                    }
                  }
                  else {
                    this.foruscareService.showNotification(response.message, "danger");
                  }
                });
            }
            else {
              this.foruscareService.showNotification("Service provider info updated successfully.", "success");
              this.toggleView();
            }
          }
        });
    }
  }

  onProviderTypeChange(newValue: String) {
    if (newValue != this.foruscareService.SERVICE_AI) {
      this.serviceProviderInfo.aiMode = null;
    }
  }

  _keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  addNewServiceProvider() {
    this.showPasswordPolicy = false;
    this.isStrongPassword = false;
    this.serviceProviderInfo = new ServiceProvider();
    this.confirmPassword = null;
    this.userInfo = new User();
  }
  languageModified(obj, action) {
    this.defaultLanguage = null;
    switch (action) {
      case "ADD":
        this.defaultLanguageList.push(obj);
        break;
      case "REMOVE":
        for (var i = 0; i < this.defaultLanguageList.length; i++) {
          if (obj.id == this.defaultLanguageList[i].id) {
            this.defaultLanguageList.splice(i, 1);
            break;
          }
        }
        break;
      case "ADD_ALL":
        this.defaultLanguageList = obj;
        break;
      case "REMOVE_ALL":
        this.defaultLanguageList.splice(0);
        break;

    }
    if (this.defaultLanguageList != null && this.defaultLanguageList.length > 0) {
      this.defaultLanguageList.sort(function (a, b) {
        if (a.itemName.split(" - ")[1] > b.itemName.split(" - ")[1]) { return 1; }
        else if (a.itemName.split(" - ")[1] < b.itemName.split(" - ")[1]) { return -1; }
        return 0;
      });
      //this.defaultLanguage = this.defaultLanguageList[0].id;
    }
  }
  /*start : check strong password */
  checkStrongPassword(password) {
    return this.foruscareService.verifyPasswordStrength(password);
  }

  /*end : check strong password */

  onExpertReviewCategoryChange(category) {
    this.expertCategory = category;
    console.log("Category --> ", category);
    // this.serviceProviderInfo.expertReviewCategory = category;
    console.log(this.serviceProviderInfo);
  }

  setupSearch(): void {
    let count = 10;
    this.serviceProviders = [];
    this.searchTerms.pipe(
      debounceTime(300),                // Wait for 300ms after the user stops typing
      distinctUntilChanged(),           // Only call the API if the term has changed
      switchMap((term: any) => this.userService.serviceProvidersSearch(term[0],term[1], count, this.offset))  // Switch to the new search term
    ).subscribe(response => {
        if (response.data != null && response.data.response.length > 0) {
          this.serviceProviders = response.data.response;
          this.totalRecords = response.data.totalCount;
          this.serviceProviders.forEach(element => {
            if (element.logo != null && element.logo.indexOf("blob.core.windows.net") > -1) {
              this.serviceProviderService.getBlobURLtobase64(element.logo)
                .subscribe(response => {
                  if (response != null && response.errorCode == 200) {
                    element.logo = "data:image/jpg;base64," + response.data;
                  }
                });
            }
          });
        }else{
          this.serviceProviders = [];
        }
            // Update the results after the API call
    });
  }
  searchData = {
    term:'',
    searchby:''
  }
  // Method triggered when typing in the search box
  onSearch(term: string, searchby:string): void {
    this.offset = 0;
    this.serviceProviders = [];
    this.paging.currentPage = 0;
    this.searchTerms.next([term,searchby]);  // Push the search term into the observable stream
    if(term && term.length > 0){
      this.searchData = {
        term:term,
        searchby:searchby
      }
    }
    else{
      this.searchData = {
        term:null,
        searchby:null
      }
    }
  }
   defaultLogo = '/assets/images/no-logo.png';
    setDefaultLogo(event: Event) {
    const img = event.target as HTMLImageElement;
    img.src = this.defaultLogo;
    }
}
